import { render, staticRenderFns } from "./BoPageHeader.vue?vue&type=template&id=01979bf5&"
import script from "./BoPageHeader.vue?vue&type=script&lang=js&"
export * from "./BoPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports